import { render, staticRenderFns } from "./VestedForm.vue?vue&type=template&id=6167986b"
import script from "./VestedForm.vue?vue&type=script&lang=js"
export * from "./VestedForm.vue?vue&type=script&lang=js"
import style0 from "./VestedForm.vue?vue&type=style&index=0&id=6167986b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports